import { format } from 'date-fns';

/**
 * Formats timestamp to "24th Jan 2026" format
 */
export const formatStakingDate = (timestamp: number): string => {
  return format(new Date(timestamp), 'do MMM yyyy');
};

/**
 * Formats Date object to display string
 */
export const formatDate = (date: Date | null): string => {
  if (!date) return '-';
  return format(date, 'do MMM yyyy');
};
